function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Geometry from './Geometry';
import GeometryCollection from './GeometryCollection';
import Dimension from './Dimension';
import Puntal from './Puntal';
var MultiPoint = /*#__PURE__*/function (_GeometryCollection) {
  function MultiPoint() {
    var _this;
    _classCallCheck(this, MultiPoint);
    _this = _callSuper(this, MultiPoint);
    MultiPoint.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(MultiPoint, _GeometryCollection);
  return _createClass(MultiPoint, [{
    key: "isValid",
    value: function isValid() {
      return true;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0];
        var tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) {
          return false;
        }
        return _superPropGet(MultiPoint, "equalsExact", this, 1).call(this, other, tolerance);
      } else return _superPropGet(MultiPoint, "equalsExact", this, 1).apply(this, arguments);
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 1 && Number.isInteger(arguments[0])) {
        var n = arguments[0];
        return this._geometries[n].getCoordinate();
      } else return _superPropGet(MultiPoint, "getCoordinate", this, 1).apply(this, arguments);
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return Dimension.FALSE;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_MULTIPOINT;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 0;
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      return this.getFactory().createGeometryCollection();
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_MULTIPOINT;
    }
  }, {
    key: "copy",
    value: function copy() {
      var points = new Array(this._geometries.length).fill(null);
      for (var i = 0; i < points.length; i++) {
        points[i] = this._geometries[i].copy();
      }
      return new MultiPoint(points, this._factory);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MultiPoint;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Puntal];
    }
  }]);
}(GeometryCollection);
export { MultiPoint as default };
MultiPoint.constructor_ = function () {
  var points = arguments[0];
  var factory = arguments[1];
  GeometryCollection.constructor_.call(this, points, factory);
};
MultiPoint.serialVersionUID = -8048474874175355449;